import React, { FC } from 'react';

import { BaseStyleEnums } from '@nhl/nhl-breakaway-ui';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';

import { GameCenterOrPlayoffSeriesTeam } from '../../types';
import { SIZING } from '../stylizedTeam/styles';

import { DecoratorContainer, PositioningContainer, Stripe, Trapezoid, Triangle } from './styles';

type Props = {
    isExpanded: boolean;
    isHome: boolean;
    isShowingGameLinks?: boolean;
    team?: GameCenterOrPlayoffSeriesTeam | null;
};

const ScoreboardDecorator: FC<Props> = ({ isHome, isShowingGameLinks = false, team = null, isExpanded }) => {
    const screenSize = useSizeWithThrottle();
    const isExtraLarge = screenSize.width >= BaseStyleEnums.ScreenWidthBreakpoints.extraLarge;
    const trianglePoints = `0,0 ${SIZING.shapeMedium},0 0,${SIZING.shapeMedium}`;

    return (
        team && (
            <DecoratorContainer
                $isExpanded={isExpanded}
                $isExtraLarge={isExtraLarge}
                $isHome={isHome}
                $isShowingGameLinks={isShowingGameLinks}
                $flipImage={(isExtraLarge && !isHome) || (!isExtraLarge && isHome)}
                $teamAbbrev={team.abbrev}
            >
                <PositioningContainer>
                    {isExtraLarge ? (
                        <Trapezoid viewBox="0 0 190 94" xmlns="http://www.w3.org/2000/svg" $teamAbbrev={team.abbrev}>
                            <path d="M172 -37L28 99H192V-3L172 -37Z" />
                            <path d="M144 -37L0 99H16L160 -37H144Z" />
                        </Trapezoid>
                    ) : (
                        <Triangle
                            $teamAbbrev={team.abbrev}
                            $isExpanded={isExpanded}
                            $isHome={isHome}
                            $isShowingGameLinks={isShowingGameLinks}
                        >
                            <polygon points={trianglePoints} />
                        </Triangle>
                    )}
                    <Stripe viewBox="0 0 115 96" xmlns="http://www.w3.org/2000/svg" $teamAbbrev={team.abbrev}>
                        {isExpanded ? (
                            <polyline points="0,96 94,0 108,0 14,96" />
                        ) : (
                            <polyline points="0,95 94,1 108,1 14,95" />
                        )}
                    </Stripe>
                </PositioningContainer>
            </DecoratorContainer>
        )
    );
};

export default ScoreboardDecorator;
